module.exports = __webpack_public_path__ + "static/media/italy_tapeguy.db8cf883.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/italy_tapeguy.jpg
// module id = 412
// module chunks = 0